import { toastController } from '@ionic/vue';

async function sendToast(
  message,
  color = 'primary',
  position = 'top',
  duration = 3000,
) {
  const toast = await toastController.create({
    message: message,
    duration,
    color,
    position,
  });

  await toast.present();
}

async function sendErrorToast(message, position = 'top', duration = 3000) {
  sendToast(message, 'danger', position, duration);
}

async function sendSuccessToast(message, position = 'top', duration = 3000) {
  sendToast(message, 'success', position, duration);
}

export { sendToast, sendErrorToast, sendSuccessToast };
